import { FC } from "react";

interface LocationIconSVGProps {
    className?: string;
    size?: number;
}

const LocationIconSVG: FC<LocationIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width={props.size || 32}
            height={props.size || 32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.6184 18.668H6.67176C6.3922 18.6681 6.11975 18.7561 5.89292 18.9195C5.6661 19.0829 5.49638 19.3135 5.40776 19.5786L2.73576 27.5786C2.66877 27.779 2.65038 27.9925 2.6821 28.2014C2.71382 28.4104 2.79474 28.6087 2.91819 28.7802C3.04164 28.9517 3.20408 29.0915 3.39213 29.1878C3.58018 29.2842 3.78845 29.3345 3.99976 29.3346H27.9998C28.2109 29.3345 28.419 29.2842 28.6069 29.1878C28.7948 29.0915 28.9572 28.952 29.0806 28.7806C29.204 28.6093 29.285 28.4111 29.3168 28.2024C29.3487 27.9936 29.3305 27.7803 29.2638 27.58L26.5971 19.58C26.5086 19.3144 26.3388 19.0833 26.1117 18.9196C25.8846 18.756 25.6117 18.6679 25.3318 18.668H20.3824M23.9998 10.668C23.9998 15.4853 18.8411 20.5733 16.8091 22.3946C16.5766 22.5722 16.2923 22.6684 15.9998 22.6684C15.7073 22.6684 15.4229 22.5722 15.1904 22.3946C13.1598 20.5733 7.99976 15.4853 7.99976 10.668C7.99976 8.54624 8.84261 6.51141 10.3429 5.01111C11.8432 3.51082 13.878 2.66797 15.9998 2.66797C18.1215 2.66797 20.1563 3.51082 21.6566 5.01111C23.1569 6.51141 23.9998 8.54624 23.9998 10.668ZM18.6664 10.668C18.6664 12.1407 17.4725 13.3346 15.9998 13.3346C14.527 13.3346 13.3331 12.1407 13.3331 10.668C13.3331 9.19521 14.527 8.0013 15.9998 8.0013C17.4725 8.0013 18.6664 9.19521 18.6664 10.668Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LocationIconSVG;
